<p-splitter
  layout="vertical"
  [panelSizes]="[75, 25]"
  [minSizes]="[25, 20]"
  [style]="{ height: 'calc(100vh - 70px - 6rem)' }"
  stateKey="bai-client-chat-demo-splitter"
  stateStorage="local"
  styleClass="bai-client-chat-splitter"
  (onResizeEnd)="scrollThreadToBottom()"
>
  <ng-template #panel>
    <!-- Multi-speaker chat thread -->
    <bai-client-chat-thread
      [sessionId]="sessionIdToUse()"
      [clientName]="clientFullName()"
      [inviterName]="userFirstName()"
    />
  </ng-template>
  <ng-template #panel>
    <div class="bai-client-chat-input-wrapper w-full h-full flex flex-col min-h-0 box-border border-t border-gray-200 bg-white">
      <!-- Smart Compose topic chips -->
      <bai-client-chat-suggestions
        [sessionId]="sessionIdToUse()"
        (selectTopic)="onTopicSelected($event)"
      />
      <!-- Composer -->
      <form
        class="bai-client-chat-input flex flex-row flex-1 min-h-0 w-full gap-2 items-stretch"
        (ngSubmit)="send()"
      >
        <textarea
          [value]="draft()"
          (input)="onInput($any($event.target).value)"
          (keydown.enter)="handleEnter($event)"
          [readonly]="composerTyping() || composerSending()"
          name="message"
          placeholder="Type your message..."
          class="bai-client-chat-textarea flex-1 p-2 border border-gray-300 rounded resize-none"
          [class.bai-client-chat-textarea--animating]="composerTyping()"
          aria-label="Client chat message"
        ></textarea>
        <p-button
          type="submit"
          label="Send"
          styleClass="p-button-outlined flex-shrink-0"
          [class.bai-client-chat-send--sending]="composerSending()"
          aria-label="Send message"
        />
      </form>
    </div>
  </ng-template>
</p-splitter>
